export const WHITELISTED_REFERRAL_URL_LIST = ['/insights-ai'];

export const IS_FIRST_SESSION = 'isFirstSession';
export const KEYWORDS_FOR_IMPORT_MERCHANT = [
  'Payment',
  'Gateway',
  'Global',
  'Business',
];
